import React from 'react';
import {
  QuestionFrontendIdentifiers,
  sections,
  TherapistSelections,
} from '../../Tabs';

interface Props {
  secKey: string; // Unique key for the section
  section: any; // Section data where edit functionalities apply
  showPage: (pageId: string) => void; // Function to navigate or display a page based on pageId
  title?: string; // Optional title for the section
  sectionData?: any; // Overrides section data for specific cases (e.g., showing therapy languages instead of therapist languages)
}

export const TherapistLanguages: React.FC<Props> = ({
  secKey,
  section,
  showPage,
  title,
  sectionData,
}) => {
  const selectedLanguageData = sectionData || section;
  const selectedLanguages = selectedLanguageData?.questions[0]?.choices?.filter(
    (choice: any) => choice?.selected === true,
  );
  let langaugeQuestionInfo;

  if (section && section?.questions) {
    section.questions = section?.questions.filter((question: any) =>
      sections[secKey].questionIdentifier.includes(
        question.frontend_identifier,
      ),
    );
    langaugeQuestionInfo = section.questions[0];
  }

  return (
    <>
      {section && (
        <TherapistSelections
          label={title || langaugeQuestionInfo?.display_title}
          value={section}
          showPage={showPage}
          mergedData={selectedLanguages}
          frontendIdentifier={
            QuestionFrontendIdentifiers.languagePage.languageTherapistQuestion
          }
        />
      )}
    </>
  );
};
